import { CardHeader, styled } from "@mui/material";

export const Header = styled(CardHeader)(({ theme }) => ({
    backgroundColor: '#003a8d',
    color: 'white',
}));
  